/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Reelplicate API
 * OpenAPI spec version: 1.0
 */

export type Platform = (typeof Platform)[keyof typeof Platform];

export const Platform = {
  TIKTOK: 'TIKTOK',
  INSTAGRAM: 'INSTAGRAM',
  YOUTUBE: 'YOUTUBE',
  LINKEDIN: 'LINKEDIN',
  FACEBOOK: 'FACEBOOK',
} as const;
